var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 124",
    id: "Facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M50.1 62.4v44.4c0 .6.5 1.2 1.2 1.2h16.5c.6 0 1.2-.5 1.2-1.2V61.6h11.9c.6 0 1.1-.5 1.2-1.1l1-13.5c.1-.7-.5-1.3-1.2-1.3h-13v-9.6c0-2.3 1.8-4.1 4.1-4.1h9.2c.6 0 1.2-.5 1.2-1.2V17.3c0-.6-.5-1.2-1.2-1.2H66.6c-9.1 0-16.5 7.4-16.5 16.5v13.1h-8.2c-.6 0-1.2.5-1.2 1.2v13.6c0 .6.5 1.2 1.2 1.2h8.2v.7z",
    clipRule: "evenodd",
    className: "color333033 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6741fadaf494b3b2385596207819e780.svg";
export { ForwardRef as ReactComponent };